import { render } from "./Taurus.vue?vue&type=template&id=59036f6e&scoped=true"
import script from "./Taurus.vue?vue&type=script&lang=js"
export * from "./Taurus.vue?vue&type=script&lang=js"

import "./Taurus.vue?vue&type=style&index=0&id=59036f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59036f6e"]])

export default __exports__